export default "__VITE_PUBLIC_ASSET__8e7aba41__"